module.exports = __webpack_public_path__ + "static/Papa_long_version_master.a3a43723.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/data/Papa_long_version_master.mp3
// module id = 215
// module chunks = 35783957827783